import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { articles, articleOrder } from '../data/articles';
import { ArrowRight, Clock } from 'lucide-react';

const content = {
  en: {
    label: 'Latest Notes',
    viewAll: 'View All Notes'
  },
  tr: {
    label: 'Son Notlar',
    viewAll: 'Tüm Notları Gör'
  },
  de: {
    label: 'Neueste Notizen',
    viewAll: 'Alle Notizen'
  }
};

export function LatestInsights() {
  const { currentLanguage } = useLanguage();
  const t = content[currentLanguage] || content.en;
  
  // Get first 2 articles
  const latestArticles = articleOrder.slice(0, 2);
  
  const getText = (obj) => obj?.[currentLanguage] || obj?.en || '';

  return (
    <section 
      className="py-16 md:py-20 bg-white"
      data-testid="latest-insights"
    >
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="flex items-center justify-between mb-10">
          <span 
            className="text-xs uppercase tracking-widest"
            style={{ color: '#0F766E', letterSpacing: '0.15em' }}
          >
            {t.label}
          </span>
          <Link
            to="/insights"
            className="inline-flex items-center gap-2 text-sm hover:gap-3 transition-all"
            style={{ color: '#0F766E' }}
          >
            {t.viewAll}
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        {/* 2 Cards */}
        <div className="grid md:grid-cols-2 gap-6">
          {latestArticles.map((articleId) => {
            const article = articles[articleId];
            if (!article) return null;
            
            return (
              <Link
                key={articleId}
                to={`/insights/${article.slug}`}
                data-testid={`latest-insight-${articleId}`}
                className="group block p-6 rounded-xl transition-all duration-300"
                style={{ 
                  background: '#F8FAFB',
                  border: '1px solid rgba(15, 118, 110, 0.1)'
                }}
                onMouseEnter={(e) => e.currentTarget.style.borderColor = 'rgba(15, 118, 110, 0.25)'}
                onMouseLeave={(e) => e.currentTarget.style.borderColor = 'rgba(15, 118, 110, 0.1)'}
              >
                {/* Category */}
                <span 
                  className="text-[10px] uppercase tracking-wider mb-3 block"
                  style={{ color: 'var(--text-on-light-subtle)' }}
                >
                  {getText(article.category)}
                </span>
                
                {/* Title */}
                <h3 
                  className="text-lg font-medium mb-3 group-hover:text-[#0F766E] transition-colors line-clamp-2"
                  style={{ color: 'var(--text-on-light-primary)' }}
                >
                  {getText(article.title)}
                </h3>
                
                {/* Meta */}
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <Clock className="w-3.5 h-3.5" style={{ color: 'var(--text-on-light-subtle)' }} />
                    <span className="text-xs" style={{ color: 'var(--text-on-light-subtle)' }}>
                      {article.readTime}
                    </span>
                  </div>
                  <ArrowRight 
                    className="w-4 h-4 group-hover:translate-x-1 transition-transform" 
                    style={{ color: '#0F766E' }} 
                  />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
